import { Client, TopicEvent, TopicSetByEvent } from 'irc-framework';
import { IRC_EVENT, IRCMessageType, tabType } from '#/types/types';
import ConnectionHandler from '#/connectionHandler';
import MessageHandler from '#/messageHandler';
import TabManager from '#/ui/tabManager';

export class TopicEventListener {
    private cH: ConnectionHandler;
    private client: Client;
    private tM: TabManager;
    private mH: MessageHandler;

    constructor(connectionHandler: ConnectionHandler) {
        this.cH = connectionHandler as ConnectionHandler;
        this.client = connectionHandler.client as Client;
        this.tM = connectionHandler.tabManager as TabManager;
        this.mH = connectionHandler.messageHandler as MessageHandler;
        this.setup();
    }

    private setup(): void {
        this.client.on(IRC_EVENT.TOPIC, (event: TopicEvent) => {
            const { nick, ident, hostname, channel, topic, time, account, tags, batch } = event;

            const channelExists = this.tM.getTab(tabType.CHANNEL, channel);
            let targetTab = this.tM.getStatusTab();

            if (channelExists) { targetTab = channelExists; }
            if (topic) {
                this.mH.addMessage(targetTab, `* Topic is '${topic}'`, IRCMessageType.SYSTEM);
            } else {
                this.mH.addMessage(targetTab, `* No topic set for ${channel}`, IRCMessageType.SYSTEM);
            }
        });

        this.client.on(IRC_EVENT.TOPICSETBY, (event: TopicSetByEvent) => {
            const { nick, ident, hostname, channel, when, tags } = event;

            const date = new Date(when * 1000)
                .toLocaleDateString(
                    'en-US', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
            });

            const targetTab =  this.tM.getTab(tabType.CHANNEL, channel) ?? this.tM.getStatusTab();
            this.mH.addMessage(targetTab, `* Topic set by ${ident}!${nick}@${hostname} on ${date}`, IRCMessageType.SYSTEM);
        });
    }
}